export default function (price, currencyCode, minDigits = 2) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode || 'USD',
    minimumFractionDigits: minDigits,
  });
  return formatter.format(parseFloat(price)).replace(/\.00$/, '');
}
